// Matt's custom BPM ranges for the Library view
// Ranges with doubleMin/doubleMax also match songs stored at double-time BPM
export const BPM_RANGES = [
  { label: '55–61',      min: 55,  max: 61  },
  { label: '62–65',      min: 62,  max: 65  },
  { label: '66–70',      min: 66,  max: 70  },
  { label: '71–75',      min: 71,  max: 75  },
  { label: '76–80',      min: 76,  max: 80  },
  { label: '81–84',      min: 81,  max: 84  },
  { label: '85–89',      min: 85,  max: 89  },
  { label: '90–95',      min: 90,  max: 95  },
  { label: '96–100',     min: 96,  max: 100 },
  { label: '101–105',    min: 101, max: 105 },
  { label: '106–109',    min: 106, max: 109 },
  { label: '110–116',    min: 110, max: 116 },
  { label: '117+',       min: 117, max: 999 },
];

// Role filter options matching song_roles in the database
export const ROLE_FILTERS = [
  { key: 'opener',  label: 'Openers'    },
  { key: 'closer',  label: 'Closers'    },
  { key: 'slow',    label: 'Slow Songs' },
  { key: 'sprint',  label: 'Sprints'    },
];

// Position filters — songs that have appeared at these playlist positions historically
// 'sl' = second-to-last (position = max - 1)
export const POSITION_FILTERS = [
  { key: 'pos2', label: 'Pos:2', position: 2    },
  { key: 'pos3', label: 'Pos:3', position: 3    },
  { key: 'pos4', label: 'Pos:4', position: 4    },
  { key: 'possl', label: 'Pos:SL', position: 'sl' },
];
